import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shorteval-motorcycle-form-component" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "mt-5 mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_component = _resolveComponent("select-component")!
  const _component_radio_component = _resolveComponent("radio-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_select_component, {
          items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
          title: '',
          name: 'fieldModel',
          id: 'fieldModel',
          "class-input": 'form-control p-3',
          placeholder: 'Modell',
          "default-title": 'Modell',
          required: true,
          "default-value": _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].predefinedManufacturerValues.manufacturerValue.vehicle.toString(),
          filter: true,
          "filter-property": ['selection', 'mainTypeGroupFb']
        }, null, 8, ["items", "default-value"]),
        _createVNode(_component_select_component, {
          items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
          title: '',
          name: 'fieldStructureType',
          id: 'fieldStructureType',
          "class-input": 'form-control p-3',
          placeholder: 'Fahrzeugtyp',
          "default-title": 'Fahrzeugtyp',
          required: true,
          filter: true,
          "filter-property": ['selection', 'structureType']
        }, null, 8, ["items"]),
        _createVNode(_component_radio_component, {
          value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldDoors.value?.toString(),
          options: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
          name: 'fieldDoors',
          gap: '',
          id: 'fieldDoors',
          title: 'Anzahl Türen',
          "div-class": 'mb-3',
          required: true,
          filter: true,
          "filter-property": ['selection','countOfDoors']
        }, null, 8, ["value", "options"]),
        _createVNode(_component_radio_component, {
          value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldFuel.value?.toString(),
          options: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
          name: 'fieldFuel',
          gap: '',
          id: 'fieldFuel',
          title: 'Kraftstoff',
          "div-class": 'mb-3',
          required: true,
          filter: true,
          "filter-property": ['selection','fuelMethod']
        }, null, 8, ["value", "options"]),
        _createElementVNode("div", {
          class: _normalizeClass(['step-4', !_ctx.isStepAvailable(_ctx.store, 4) ? 'hidden' : ''])
        }, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.labels.chapterDriveAndPerformance), 1),
          _createVNode(_component_select_component, {
            items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
            title: '',
            name: 'fieldEngine',
            id: 'fieldEngine',
            "class-input": 'form-control p-3',
            placeholder: 'Motorisierung',
            "default-title": 'Motorisierung',
            required: true,
            filter: true,
            "filter-property": ['selection', 'engine']
          }, null, 8, ["items"]),
          _createVNode(_component_radio_component, {
            value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldDriveType.value?.toString(),
            options: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
            name: 'fieldDriveType',
            gap: '',
            id: 'fieldDriveType',
            title: 'Antriebsart',
            "div-class": 'mb-3',
            required: true,
            filter: true,
            "filter-property": ['selection','driveType']
          }, null, 8, ["value", "options"]),
          _createVNode(_component_radio_component, {
            value: _ctx.store.getters[`form/${_ctx.FormGetters.GET_INPUTS}`].fieldGearType.value?.toString(),
            options: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
            name: 'fieldGearType',
            gap: '',
            id: 'fieldGearType',
            title: 'Getriebeart',
            "div-class": 'mb-3',
            required: true,
            filter: true,
            "filter-property": ['selection','gearType']
          }, null, 8, ["value", "options"]),
          _createVNode(_component_select_component, {
            items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
            title: '',
            name: 'fieldModelType',
            id: 'fieldModelType',
            "class-input": 'form-control p-3',
            placeholder: 'Modellvariante',
            "default-title": 'Modellvariante',
            required: true,
            filter: true,
            "filter-property": ['selection', 'mainTypeFb']
          }, null, 8, ["items"]),
          _createVNode(_component_select_component, {
            items: _ctx.store.getters[`form/${_ctx.FormGetters.GET_DATA}`].filters.value,
            title: '',
            name: 'fieldSubType',
            id: 'fieldSubType',
            "class-input": 'form-control p-3',
            placeholder: 'Modellversion',
            "default-title": 'Modellversion',
            required: true,
            filter: true,
            "filter-property": ['selection', 'subType']
          }, null, 8, ["items"]),
          _createVNode(_component_select_component, {
            items: _ctx.carsBelowThreshold,
            title: '',
            name: 'vehicleSelected',
            id: 'vehicleSelected',
            "class-input": 'form-control p-3',
            placeholder: 'Ausstattungslinie',
            "default-title": 'Ausstattungslinie',
            required: true,
            filter: false
          }, null, 8, ["items"])
        ], 2)
      ])
    ])
  ]))
}